import React from 'react';
import { Switch, useRouteMatch } from 'react-router-dom';

import { RouteWhenAuthenticated } from 'common/components';
import { ExperienceEntityType, PageHeader, useExperienceModuleContext } from 'modules/experience-core';

import { DetailVenueGroup, ListingVenueGroup } from './components/venue-group';

export const ExperienceBrandVenueGroup = () => {
  const { path } = useRouteMatch();

  const {
    experienceEntity: { experienceEntityObject, experienceEntityType },
  } = useExperienceModuleContext();
  if (experienceEntityType !== ExperienceEntityType.BRAND) {
    return null;
  }

  return (
    <>
      <PageHeader enableSelector={false} />
      <Switch>
        <RouteWhenAuthenticated exact path={`${path}`}>
          <ListingVenueGroup brand={experienceEntityObject} isExperienceFlow />
        </RouteWhenAuthenticated>
        <RouteWhenAuthenticated exact path={`${path}/:venueGroupId`}>
          <DetailVenueGroup brand={experienceEntityObject} isExperienceFlow />
        </RouteWhenAuthenticated>
      </Switch>
    </>
  );
};
